export const PAGE_NAME_MAPPING = {
  overview: 'Overview',
  channel: 'Channel',
  channels: 'Channels',
  invoices: 'Invoices',
  creator: 'Channels',
  sales: 'Sales',
  orders: 'Orders',
  costs: 'Costs',
  payment: 'Payment',
  request: 'Request',
  settings: 'Settings',
  editAdvertiser: 'Edit Advertiser',
  logout: 'Logout',
  emailSent: 'Email Sent',
  onboarding: 'Onboarding',
  campaigns: 'Campaigns',
  createCampaign: 'Create Campaign',
  editCampaign: 'Edit Campaign',
  campaignParticipants: 'Campaign Participants',
  wooCommerce: 'WooCommerce',
  salesPixel: 'Javascript Pixel Integration',
  shopify: 'Shopify Integration',
  notFound: 'Not Found',
  error: 'Error',
  adminError: 'Error',
  contentLibrary: 'Content Library',
  segments: 'Segments',
  segmentCreate: 'Create segment',
  segmentEdit: 'Edit segment',
}
